import { StyledLogo } from './logo.styled';

export const Logo = () => {
  return (
    <StyledLogo>
      <img src="/images/logo.svg" alt="КлеверПарк" width={158} height={42} />
    </StyledLogo>
  );
};

export default Logo;
